// extracted by mini-css-extract-plugin
module.exports = {"storeTitle":"AccordionTitle_storeTitle__JQQjM","cost":"AccordionTitle_cost__FNBA6","eco":"AccordionTitle_eco__S_Hah"};